export const RESULTADO_LOADING = 'LOADING'
export const RESULTADO_ERRO = 'ERRO_CONSULTA'

export const criarFetchMerged = (service, dispatch, unidade) => (url, kpiKey, cachedParams, todayParams) => {
    const buscar = (p) => service.get(url, p).catch(err => {
        console.error(`Falha ao consultar ${url}:`, err)
        return RESULTADO_ERRO
    })

    const guardarRecorteDeHoje = (records) =>
        dispatch({ type: 'UPDATE_TODAY_SLICES', kpi: kpiKey, records, unidade })

    if (!todayParams) {
        guardarRecorteDeHoje([])
        return buscar(cachedParams)
    }

    return Promise.all([
        buscar(cachedParams),
        buscar(todayParams),
    ]).then(([cachedResult, todayResult]) => {
        const today = Array.isArray(todayResult) ? todayResult : []

        guardarRecorteDeHoje(today)

        if (cachedResult === RESULTADO_ERRO || todayResult === RESULTADO_ERRO) {
            return RESULTADO_ERRO
        }

        if (cachedResult === RESULTADO_LOADING) {
            return RESULTADO_LOADING
        }

        const cached = Array.isArray(cachedResult) ? cachedResult : []

        return [...cached, ...today]
    })
}
